import React, { useEffect, useRef } from 'react';
import clsx from 'clsx';
import { Scrollbars } from 'react-custom-scrollbars';
import { IconClose } from 'src/icons';
import styles from './Modal.module.scss';

type Props = {
  label: string;
  className?: string;
  children?: React.ReactNode;
  onClick?: (e: React.MouseEvent<HTMLDivElement | HTMLButtonElement>) => void;
  open: boolean;
  variant?: 'wide';
};

const Modal = React.forwardRef<HTMLDivElement, Props>((props): JSX.Element => {
  const {
    label,
    className,
    children,
    onClick,
    open,
    variant,
    ...other
  } = props;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView();
  }, [open]);

  return (
    <div className={clsx(styles.container, open && styles.isActive, className)} {...other}>
      <div className={styles.overlay} onClick={onClick} />
      <div className={clsx(styles.contents, variant && styles[variant])}>
        <header className={styles.header}>
          <div className={styles.spacer} />
          <h2 className={styles.title}>{label}</h2>
          <button
            className={styles.closeButton}
            onClick={onClick}
          >
            <IconClose />
          </button>
        </header>
        <Scrollbars className={styles.body}>
          <div ref={ref} className={styles.inner}>{children}</div>
        </Scrollbars>
      </div>
    </div>
  );
});

export default React.memo(Modal);